import React from 'react';
import FooterOne from '../common/footer/FooterOne';
import HeaderOne from '../common/header/HeaderOne';
import SEO from '../common/SEO';
import AboutOne from '../component/about/AboutOne';
import BannerOne from '../component/banner/BannerOne';
import BlogOne from '../component/blog/BlogOne';
import BrandOne from '../component/brand/BrandOne';
import CounterUpOne from '../component/counterup/CounterUpOne';
import CtaLayoutOne from '../component/cta/CtaLayoutOne';
import PricingOne from '../component/pricing/PricingOne';
import ProjectOne from '../component/project/ProjectOne';
import ServicePropOne from '../component/service/ServicePropOne';
import TestimonialOne from '../component/testimonial/TestimonialOne';
import SectionTitle from '../elements/section-title/SectionTitle';

const DigitalAgency = () => {   

    return (
        <>
        <SEO title="Digital Agency"/>
        <main className="main-wrapper">
            <HeaderOne />

            {/* Add an ID for the Home/Banner section */}
            <section id="home">
                <BannerOne />
            </section>

            {/* Add an ID for the Services section */}
            <section id="services" className="section section-padding-2 bg-color-dark">
                <div className="container">
                    <SectionTitle 
                        subtitle="How We Can Do For You"
                        title="What Sets Us Apart"
                        description="This can definitely be made more professional and aligned with an IT company like Graphify Infotech."
                        textAlignment="heading-light-left"
                        textColor=""
                    />
                    <div className='row'>
                        <ServicePropOne colSize="col-xl-4 col-md-6" serviceStyle="" itemShow="6" />
                    </div>
                </div>
                <ul className="list-unstyled shape-group-10">
                    <li className="shape shape-1"><img src={"/images/others/line-9.png"} alt="Circle" /></li>
                    <li className="shape shape-2"><img src={"/images/others/bubble-42.png"} alt="Circle" /></li>
                    <li className="shape shape-3"><img src={"/images/others/bubble-43.png"} alt="Circle" /></li>
                </ul>
            </section>

            {/* Add an ID for the About Us section */}
            <section id="about-us">
                <AboutOne />
            </section>

            {/* Add an ID for the Projects section */}
            <section id="projects">
                <ProjectOne />
            </section>
             <BrandOne />
            {/* Add an ID for the Contact section */}
            <section id="contact">
                <CtaLayoutOne /> 
            </section>
            
           
            <FooterOne parentClass="" />
        </main>
        </>
    )
}

export default DigitalAgency;